import { useMemo } from 'react';

import useClientState from '@/state/useClientState';

import { generate10MinTickValues, generateDayTickValues } from '../../utils/timescale';
import { MwdTimescale } from '../types/MwdStore';

export type MwdVariant = 'mwd' | 'miniMwd';

type MwdTimescaleResult = MwdTimescale & {
  tickValues10Minutes: Date[];
  tickValuesDays: Date[];
};

const useMwdTimescale = (variant: MwdVariant = 'mwd'): MwdTimescaleResult => {
  const scale = useClientState((state) => state[variant].scale);
  const start = useClientState((state) => state[variant].start);
  const end = useClientState((state) => state[variant].end);

  const { tickValues10Minutes, tickValuesDays } = useMemo(() => {
    return {
      /** Get the scalar props for 10MinuteGridProps: hoursInView * 6(10minutesinanhour) - 1 */
      tickValues10Minutes: generate10MinTickValues(start, end),
      /** Get the scalar props for the Day labels: include 'end' as well. */
      tickValuesDays: generateDayTickValues(start, end),
    };
  }, [start, end]);

  return { scale, start, end, tickValues10Minutes, tickValuesDays };
};

export default useMwdTimescale;
